const SWITCHER_START_EVENT = "wishlist:switcher:start";
const SWITCHER_END_EVENT = "wishlist:switcher:end";
const SWITCHER_SUCCESS_EVENT = "wishlist:switcher:success";
const SWITCHER_ERROR_EVENT = "wishlist:switcher:error";

const $document = $(document);

export function onSwitcherStart(cb) {
    $document.on(SWITCHER_START_EVENT, cb);
}

export function onSwitcherEnd(cb) {
    $document.on(SWITCHER_END_EVENT, cb);
}

export function onSwitcherSuccess(cb) {
    $document.on(SWITCHER_SUCCESS_EVENT, cb);
}

export function onSwitcherError(cb) {
    $document.on(SWITCHER_ERROR_EVENT, cb);
}

export function offSwitcherStart(cb) {
    $document.off(SWITCHER_START_EVENT, cb);
}

export function offSwitcherEnd(cb) {
    $document.off(SWITCHER_END_EVENT, cb);
}

export function offSwitcherSuccess(cb) {
    $document.off(SWITCHER_SUCCESS_EVENT, cb);
}

export function offSwitcherError(cb) {
    $document.off(SWITCHER_ERROR_EVENT, cb);
}

export function emitSwitcherStart(cb) {
    $document.trigger(SWITCHER_START_EVENT, cb);
}

export function emitSwitcherEnd(cb) {
    $document.trigger(SWITCHER_END_EVENT, cb);
}

export function emitSwitcherSuccess(cb) {
    $document.trigger(SWITCHER_SUCCESS_EVENT, cb);
}

export function emitSwitcherError(cb) {
    $document.trigger(SWITCHER_ERROR_EVENT, cb);
}
